import resources from '@/crud/index/index'

export default {
  mixins: [resources],

  resourcePath: '/v1/patient/scheduling/schedules'
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/resources/resources.js